import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const stripeApi = createApi({
  reducerPath: "stripeApi",
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ["stripe"],
  endpoints: builder => ({
    paymentWithCheckoutPage: builder.mutation({
      query: body => {
        return {
          url: spotFinder.StripeController.paymentWithCheckoutPage,
          method: 'POST',
          headers: body.token ? {Authorization: `Bearer ${body.token}`} : {},
          body: body.payload,
        };
      },
    }),
    createOrder: builder.mutation({
      query: body => {
        return {
          url: spotFinder.CashfreeController.createOrder,
          method: 'POST',
          headers: body.token ? {Authorization: `Bearer ${body.token}`} : {},
          body: body.payload,
        };
      },
    }),
    createCustomer: builder.mutation({
      query: body => {
        return {
          url: spotFinder.CashfreeController.createCustomer,
          method: 'POST',
          headers: body.token ? {Authorization: `Bearer ${body.token}`} : {},
          body: body.payload,
        };
      },
    }),
    createOrderRazorpay: builder.mutation({
      query: body => {
        return {
          url: spotFinder.RazorpayController.createOrderRazorpay,
          method: 'POST',
          headers: body.token ? {Authorization: `Bearer ${body.token}`} : {},
          body: body.payload,
        };
      },
    }),
    getAllPaymentMethod: builder.mutation({
      query: body => {
        return {
          url: spotFinder.PaymentMethodController.getAllPaymentMethod,
          method: 'GET',
          headers: body.token ? {Authorization: `Bearer ${body.token}`} : {},
          body: body.payload,
        };
      },
    })
  }),
});


export const {useGetAllPaymentMethodMutation, usePaymentWithCheckoutPageMutation, useCreateOrderMutation, useCreateOrderRazorpayMutation ,useCreateCustomerMutation} = stripeApi
